import { handleActions } from 'redux-actions';
import { InitializationStatus, DamzState } from '../../types';
import {
  authInitializationComplete,
  damzOffline,
  damzOnline,
  reduxInitializationFailed,
  reduxInitialized,
  translationsImportFailed,
  translationsPreparedForImport,
} from '../actions/initialization';

export default handleActions<DamzState['initialization'], any>(
  {
    [`${reduxInitialized}`]: state => ({
      ...state,
      isReduxInitialized: InitializationStatus.Success,
    }),
    [`${reduxInitializationFailed}`]: state => ({
      ...state,
      isReduxInitialized: InitializationStatus.Failure,
    }),
    [`${translationsPreparedForImport}`]: state => ({
      ...state,
      areTranslationsInitialized: InitializationStatus.Success,
    }),
    [`${translationsImportFailed}`]: state => ({
      ...state,
      areTranslationsInitialized: InitializationStatus.Failure,
    }),
    [`${damzOnline}`]: state => ({
      ...state,
      online: true,
    }),
    [`${damzOffline}`]: state => ({
      ...state,
      online: false,
    }),
    [`${authInitializationComplete}`]: state => ({
      ...state,
      authInitializationAttempted: true,
    }),
  },
  {
    isReduxInitialized: InitializationStatus.Initializing,
    areTranslationsInitialized: InitializationStatus.Initializing,
    online: false,
    authInitializationAttempted: false,
  }
);
